"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.element = void 0;
var js_1 = require("./js");
var element;
(function (element) {
    element.createModeElement = function (ids, onSelect, chkSelect) {
        var modes = [];
        ids.some(function (id) {
            var elm = js_1.js.gE(id);
            modes.push(elm);
            elm.onclick = function () {
                if (!chkSelect(elm.id))
                    return;
                modes.some(function (span) {
                    span.setAttribute("select", "off");
                });
                elm.setAttribute("select", "on");
                onSelect(elm.id);
            };
        });
        // click on/off の状態を設定する
        var setState = function () {
            modes.some(function (span) {
                if (chkSelect(span.id)) {
                    span.setAttribute("disabled", "off");
                    if (span.getAttribute("select") == "on") {
                        span.setAttribute("select", "off");
                        onSelect("");
                    }
                }
                else {
                    span.setAttribute("disabled", "on");
                }
            });
        };
        // 指定モードに設定する
        var setMode = function (id) {
            if (!chkSelect(id))
                return;
            modes.some(function (span) {
                if (span.id == id)
                    span.setAttribute("select", "on");
                else
                    span.setAttribute("select", "off");
            });
            onSelect(id);
        };
        // 現在のモードを取得する
        var getMode = function () {
            var id = "";
            modes.some(function (span) {
                if (span.getAttribute("select") == "on") {
                    id = span.id;
                    return true;
                }
            });
            return id;
        };
        return { setState: setState, setMode: setMode, getMode: getMode };
    };
})(element = exports.element || (exports.element = {}));
